module.exports = {
    "APICONTACTO": "https://serf.aws.libertyfianzas.com/api-contacto",
    "APIBOLASAGENTE": "https://ip-10-234-45-95.aws.lmig.com/api-contacto/",
    "API_SESSION": "https://api.us.libertymutual.com/session",
    "API_SESSION_KEY": "oM4Fr5NibElI0zuNgmAnNTDtO4frLZRCkGd8AQplGMIsLASw",
    "API_GENERAL": "https://api.us.libertymutual.com/apigeneral",
    "API_GENERAL_KEY": "GXUmrQJ58IlOLv1TO6X7qHxNGpoNu9e5D5YT1ImRCgTMChrJ",
    "env": "prod"
}